import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import banner1 from "../../Assets/Banner/Welcome-back-school-1.jpg";
import banner2 from "../../Assets/Banner/Welcome-back-school-2.jpg";
import banner3 from "../../Assets/Banner/banner01.jpg";
import banner4 from "../../Assets/Banner/banner02.jpg";
import banner5 from "../../Assets/Banner/banner03.jpg";
import banner6 from "../../Assets/Banner/banner04.jpg";
import "./NewBanner.css";
import { useNavigate } from "react-router-dom";

const NewBanner = ({ hero }) => {
  const navigate = useNavigate();
  const images = [
    // {
    //   id: 1,
    //   image: banner1,
    //   alt: "Banner 1",
    // },
    // {
    //   id: 2,
    //   image: banner2,
    //   alt: "Banner 2",
    // },
    {
      id: 3,
      image: banner3,
      alt: "Banner 3",
    },
    {
      id: 4,
      image: banner4,
      alt: "Banner 4",
    },
    {
      id: 5,
      image: banner5,
      alt: "Banner 5",
    },
    {
      id: 6,
      image: banner6,
      alt: "Banner 6",
    },
  ];

  return (
    <div className="new-banner">
      <Swiper
        modules={[Navigation, Autoplay]}
        slidesPerView={1}
        //   navigation
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        loop
        className="banner-swiper"
      >
        {images.map((item) => (
          <SwiperSlide key={item.id}>
            <img src={item.image} alt={item.alt} />
          </SwiperSlide>
        ))}
      </Swiper>
      <div className="Banner-box">
        <h1>{hero?.Heading}</h1>
        <h2>{hero?.description1}</h2>
        <h2>{hero?.description2}</h2>
        <div className="banner-item-btn">
          <button
            className="btn-fill"
            onClick={() => navigate(hero?.primaryLink)}
          >
            {hero?.primaryButton}
          </button>
          <button
            className="btn-outline"
            onClick={() => navigate(hero?.secondaryLink)}
          >
            {hero?.secondaryButton}
          </button>
        </div>
      </div>
    </div>
  );
};

export default NewBanner;
